import React from "react";
import { RiUserAddLine } from "react-icons/ri";
import EmptyState from "../ui/EmptyState/EmptyState";

const FeedEmptyState = ({ onFindFriends }) => (
  <EmptyState
    icon={RiUserAddLine}
    title="Your feed is quiet"
    description="Log a workout or add friends to see their training show up here."
    action={
      onFindFriends && (
        <button type="button" className="btn btn-primary" onClick={onFindFriends}>
          Find Friends
        </button>
      )
    }
  />
);

export default FeedEmptyState;
